<template>
  <div class="wrap">
    <JNav :title="$t('绑定电子钱包')" />
    <div class="cont">
      <div class="tab_title">{{ $t('选择电子钱包组') }}</div>
      <div class="cont_tab">
        <div class="tab_item" :class="index == tabActive ? 'tab_active' : ''" v-for="item, index in tab" :key="index"
          @click="tabClick(item, index)">
          <img :src="item.icon" v-if="item.icon">
          <div v-else>{{ $t(item.titles) }}</div>
        </div>
      </div>
      <div class="cont_bank">
        <template v-if="tabActive == 0">
          <div class="bank_title">{{ $t('钱包类型') }}</div>
          <div class="banks">
            <div class="bank_item" :class="typeNum == index ? 'bank_active' : ''" v-for="item, index in cardType"
              :key="index" @click="tabTypeClick(item, index)">
              <img :src="$img(item.icon)" alt="">
              {{ item.name }}
            </div>
          </div>
          <div class="form_item">
            <div class="label">{{ $t('地址') }}</div>
            <Field v-model="form.card" :placeholder="$t('请输入地址')" />
          </div>
          <!-- <div class="form_item">
            <div class="label">{{ $t('账户姓名') }}</div>
            <Field v-model="form.name" :placeholder="$t('请输入账号姓名')" />
          </div> -->
        </template>
        <template v-else>
          <div class="form_item">
            <div class="label">{{ $t('账号') }}</div>
            <Field v-model="form1.card" :placeholder="$t('请输入账号')" />
          </div>
          <div class="form_item">
            <div class="label">{{ $t('账户姓名') }}</div>
            <Field v-model="form1.name" :placeholder="$t('请输入账号姓名')" />
          </div>
          <div class="form_item">
            <div class="label">{{ $t('银行名称') }}</div>
            <Field v-model="form1.bank" :placeholder="$t('请填写银行名称')" />
          </div>
          <div class="form_item">
            <div class="label">{{ $t('newAdd.IFSCCODE') }}</div>
            <Field v-model="form1['ifsc_code']" :placeholder="$t('请填写IFSC')" />
          </div>
          <!-- <div class="form_item">
            <div class="label">{{ $t('用户名') }}</div>
            <Field v-model="form1.name" :placeholder="$t('请填写用户名')" />
          </div> -->
          <!-- <div class="form_item">
            <div class="label">{{ $t('银行代码') }}</div>
            <Field v-model="form1.card" :placeholder="$t('请填写银行代码')" />
          </div> -->

        </template>
        <!-- <div class="form_item">
          <div class="label">{{ $t('交易密码') }}</div>
          <Field v-model="paypass" :placeholder="$t('请输入交易密码')" />
        </div> -->
        <!-- <div class="bank_switch">
          <div class="label">{{ $t('设为默认') }}</div>
          <van-switch active-color="#ff3a3e" v-model="checked" />
        </div> -->
      </div>
      <div class="btn" @click="submit">{{ $t('newAdd.Submit') }}</div>
    </div>
  </div>
</template>
<script>
import JNav from "@/components/JNav"
import { Field, Switch, Toast, Dialog } from "vant";
import { COMMIT_USER_BANK_INFO, GET_USER_BANK_INFO, PAY_WTYPE } from "@/api"
export default {
  components: {
    JNav,
    Field,
    [Switch.name]: Switch,
    Toast,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      tab: [{
        // icon: require('@/assets/new/bank/gcash.jpg'),
        titles: '加密货币',
        title: 'crypto'
      },
      {
        titles: 'newAdd.cardTabBank',
        title: 'bank'
      }],
      tabActive: 0,
      checked: false,
      cardType: [],
      typeNum: 0,
      form: {
        name: '', // name
        card: '', // 地址
        open: 'crypto', // tab.title
        bank: '' // code
      },
      form1: {
        name: '',
        card: '',
        bank: '',
        open: 'bank',
        'ifsc_code':''
      },
      walletID: '',
      paypass: '',
    }
  },
  created() {
    // this.getUserInfo();
    this.getBankType();
    const { id } = this.$route.query;
    if (!!id) {
      this.walletID = id;
      this.$nextTick(() => {
        this.getUserBankInfo();
      })
    }
  },
  methods: {
    tabTypeClick(item, index) {
      this.typeNum = index;
      this.form = { ...this.form, name: item.name, bank: item.code };
    },
    async getBankType() {
      Toast.loading();
      try {
        const res = await PAY_WTYPE();
        const banks = res.data.filter(item=>item.name != 'BANK');
        this.form = { ...this.form, name: banks[this.typeNum].name, bank: banks[this.typeNum].code }
        this.cardType = banks;
        Toast.clear();
      } catch (error) {
        Toast.clear();
      }
    },
    tabClick(item, index) {
      // if (item.title == this.tabActive) return;
      // if (index == 1) return Toast(this.$t('正在维护'));
      // this.tabActive = item.title;
      this.tabActive = index
    },
    submit() {
      if (this.tabActive == 0) {
        if (!this.form.card) return Toast(this.$t('请输入地址'));
      }
      if (this.tabActive == 1) {
        if (!this.form1.card) return Toast(this.$t('请输入账号'));
        if (!this.form1.name) return Toast(this.$t('请输入账号姓名'));
        if (!this.form1.bank) return Toast(this.$t('请填写银行名称'));
        if (!this.form1['ifsc_code']) return Toast(this.$t('请填写IFSC'));
      }
      // if (!this.paypass) return Toast(this.$t('请输入交易密码'));
      Toast.loading();
      let params = this.tabActive == 0 ? { ...this.form } : { ...this.form1 }
      COMMIT_USER_BANK_INFO({ ...params, default: this.checked ? 1 : 0 }).then(res => {
        Toast.clear();
        const { ret, msg } = res.data;
        if (ret == 1) {
          Toast(msg);
          this.$router.go(-1);
        } else {
          Toast(msg)
        }
      }).catch((e) => {
        Toast.clear();
      });
    },
    getType(item) {
      const { bank } = item;
      if (bank == 'GCASH') {
        this.tabActive = "GCASH";
        this.form.id = item.id;
        this.form.name = item.name;
        this.form.card = item.card;
        this.checked = item.default > 0 ? true : false;
        return
      }
      this.tabActive = "MAYA";
      this.form.id = item.id;
      this.form1.name = item.name;
      this.form1.card = item.card;
      this.form1.open = item.open;
      this.checked = item.default > 0 ? true : false;
    },
    getUserBankInfo() {
      Toast.loading();
      GET_USER_BANK_INFO({ id: this.walletID }).then((r) => {
        Toast.clear();
        const { data } = r.data;
        if (r.data.ret === 1 && data.length > 0) {
          this.getType(data[0])
        }
      }).catch((e) => { Toast.clear(); });
    },
    getUserInfo() {
      Toast.loading();
      this.$api.getUserInfo((res) => {
        Toast.clear();
        if (res.setpaypass > 0) { } else {
          Dialog.alert({
            message: this.$t('未设置交易密码'),
            showCancelButton: true,
            confirmButtonText: this.$t('My.Button.Two'),
            cancelButtonText: this.$t('My.Button.One')
          }).then(() => {
            this.$router.push('/PaymentCode')
          }).catch(() => {
            this.$router.back();
          });
        }
      }, (err) => { Toast.clear(); });
    },
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: #f5f5f9;

  .cont {
    padding: 0 5% calc(16rem / 16);

    .tab_title {
      margin-top: calc(25rem / 16);
      color: #747474;
      font-size: calc(14rem / 16);
    }

    .cont_tab {
      padding: calc(10rem / 16) 0 calc(15rem / 16);
      display: flex;
      align-items: center;
      gap: calc(10rem / 16);

      .tab_item {
        width: 30%;
        height: calc(39rem / 16);
        // padding: calc(2.5rem / 16);
        border-radius: calc(8rem / 16);
        border: 1px solid #e4e4e4;
        background: var(--light);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 100%;
          max-height: 100%;
          object-fit: contain;
          display: block;
        }
      }

      .tab_active {
        border-color: #ff3039;
        background: rgba(255, 48, 57, .06);
      }
    }

    .cont_bank {
      border-radius: calc(8rem / 16);
      border: 1px solid rgba(0, 0, 0, .2);
      background-color: var(--light);
      padding: calc(10rem / 16) calc(5rem / 16);

      .bank_title {
        color: #747474;
        font-size: calc(14rem / 16);
        margin-bottom: calc(10rem / 16);
      }

      .banks {
        display: flex;
        align-items: center;
        gap: calc(10rem / 16);
        flex-wrap: wrap;

        .bank_item {
          width: calc((100% - 10px - 10px - 4px) / 2);
          height: calc(39rem / 16);
          border: 1px solid #e4e4e4;
          background-color: var(--light);
          padding: calc(2.5rem / 16);
          border-radius: calc(8rem / 16);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          img{
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: block;
          }
        }

        .bank_active {
          border-color: #ff3039;
          background: rgba(255, 48, 57, 0.06);
        }
      }


      .form_item {
        padding-top: calc(15rem / 16);

        .label {
          color: #333;
          font-size: calc(14rem / 16);
          padding-bottom: calc(10rem / 16);
        }

        /deep/ .van-cell {
          background-color: #efefef;
          color: #333;
          padding: 0 calc(12rem / 16);
          height: calc(52rem / 16);
          line-height: calc(52rem / 16);
          border-radius: calc(7.5rem / 16);
        }
      }

      .bank_switch {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: calc(16rem / 16) 0;
        gap: calc(10rem / 16);

        .label {
          color: #333;
          font-size: calc(14rem / 16);
        }
      }
    }

    .btn {
      background: var(--btn_bg);
      height: calc(42rem / 16);
      padding: calc(5rem / 16) calc(10rem / 16);
      font-size: calc(14rem / 16);
      color: var(--light);
      text-align: center;
      line-height: 42rem / 16;
      border-radius: calc(8rem / 16);
      margin-top: calc(16rem / 16);
    }
  }
}
</style>